import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import classnames from "classnames";
import React, { useState } from "react";
import GenericModal from "web/react/components/generic-modal/generic-modal";
import PaywallMarkup from "web/react/components/paywall-markup/paywall-markup";
import SendToApp from "web/react/components/send-to-app/send-to-app";
import SendToAppWithTrackedLink from "web/react/components/send-to-app-with-tracked-link/send-to-app-with-tracked-link";
import { useSmallBreakpoint } from "web/react/hooks/use-breakpoint/use-breakpoint";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import environment from "web/script/modules/environment";
import styles from "./send-to-app-modal.css";

function SendToAppModal(_ref) {
  var _classnames;

  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      title = _ref.title,
      url = _ref.url,
      analyticsEventLabel = _ref.analyticsEventLabel,
      paywalledClassName = _ref.paywalledClassName,
      productImageURL = _ref.productImageURL,
      appDeepLinkURL = _ref.appDeepLinkURL,
      trackedLink = _ref.trackedLink,
      financialIncentiveWebviewToken = _ref.financialIncentiveWebviewToken,
      downloadCTA = _ref.downloadCTA;
  var smallScreen = !useSmallBreakpoint();
  var bottomModal = environment.getFeature("mg_ios_modal_bottom") && smallScreen;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      closed = _useState2[0],
      setClosed = _useState2[1]; // "Download the Lyst App for free"


  downloadCTA = downloadCTA ? downloadCTA : gettext("feed.show_more.app_overlay.cta");

  function handleOpen() {
    setClosed(false);
  }

  function onModalClose() {
    setClosed(true);
    analytics.event("app_overlay", "modal_dismissed", analyticsEventLabel);
    onClose();
  }

  return React.createElement(React.Fragment, null, React.createElement(GenericModal, {
    isOpen: isOpen,
    onAfterOpen: handleOpen,
    onClose: onModalClose,
    className: classnames((_classnames = {}, _defineProperty(_classnames, styles.modal, bottomModal), _defineProperty(_classnames, styles.closed, closed && bottomModal), _classnames))
  }, !trackedLink ? React.createElement(SendToApp, {
    analyticsEventLabel: analyticsEventLabel,
    title: title,
    url: url,
    productImageURL: productImageURL,
    downloadCTA: downloadCTA
  }) : React.createElement(SendToAppWithTrackedLink, _extends({
    analyticsEventLabel: analyticsEventLabel,
    title: title,
    url: url,
    productImageURL: productImageURL,
    downloadCTA: downloadCTA,
    className: styles.withTrackedLinkContainer,
    appDeepLinkURL: appDeepLinkURL,
    financialIncentiveWebviewToken: financialIncentiveWebviewToken
  }, trackedLink))), paywalledClassName && React.createElement(PaywallMarkup, {
    cssSelector: paywalledClassName
  }));
}

export default SendToAppModal;